import {useTheme} from '@mui/material';
import {TextDiv, WrapperDiv} from './ComponentLoaderStyle';
import {PulseLoader} from 'react-spinners';

interface ComponentLoaderProps {
  loaderSize?: number;
  text?: string;
  padding?: string;
  // eslint-disable-next-line react/boolean-prop-naming
  flowSheetScreen?: boolean;
}

const ComponentLoader = (props: ComponentLoaderProps): JSX.Element => {
  const theme = useTheme();
  const {
    text,
    loaderSize = 5,
    padding = '0px',
    flowSheetScreen = false
  } = props;
  return (
    <WrapperDiv padding={padding} isFlowSheetScreen={flowSheetScreen}>
      <PulseLoader size={loaderSize} color={theme.palette.primary.main} />
      {text && (
        <TextDiv>
          <span>{text}</span>
        </TextDiv>
      )}
    </WrapperDiv>
  );
};

export default ComponentLoader;
